import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import moment from 'moment';
import { noop } from 'lodash';

import TimeDisplay from './TimeDisplay';
import PropTypeCampaign from '../utilities/propTypes/PropTypeCampaign';
import { PropTypeStatusIsRequired } from '../utilities/propTypes/PropTypeStatus';
import { CampaignStatuses } from '../constants';

const Campaign = ({
  id,
  name,
  status,
  tokenLabel,
  formattedTokensPerCode,
  timestamp,
  transactionHash,
  onDiscardCampaign,
}) => (
  <div className={classNames({ campaign: true, [`campaign-${id}`]: true })}>
    <div className="label">Name</div>
    <div className="item name">
      <span>{name}</span>
    </div>
    <div className="label">Status</div>
    <div className="item status">
      <span className={status.toString()}>{status.toString()}</span>
    </div>
    <div className="label">Token Name</div>
    <div className="item token">
      <span>{tokenLabel}</span>
    </div>
    <div className="label">Tokens Per Code</div>
    <div className="item tokens-per-code">
      <span>{formattedTokensPerCode}</span>
    </div>
    <div className="label">Date Created</div>
    <div className="item date">
      <TimeDisplay date={moment.unix(timestamp).toDate()} />
    </div>
    <div className="item options">
      {!status.is(CampaignStatuses.failed) && (
        <NavLink className="btn" to={`/manage-campaigns/${transactionHash}`}>
          Manage
        </NavLink>
      )}
      {status.is(CampaignStatuses.failed) && (
        <button className="btn remove" onClick={() => onDiscardCampaign(id)}>
          Remove
        </button>
      )}
    </div>
  </div>
);

Campaign.displayName = 'Campaign';

Campaign.defaultProps = {
  onDiscardCampaign: noop,
};

const PropTypeStatus = {
  isRequired: PropTypeStatusIsRequired,
};
Campaign.propTypes = {
  ...PropTypeCampaign,
  ...PropTypeStatus.isRequired,
  onDiscardCampaign: PropTypes.func,
};

export default Campaign;



// WEBPACK FOOTER //
// ./src/components/Campaign.js